import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";
import { readApiErrorMessage } from "../utils/clientRestrictionsUi";

export const fetchClientPolls = async () => {
    const response = await apiFetch(`${API_BASE}/polls/client`);
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};

export const createClientPoll = async ({ question, expires_at, network_id = null, location_id = null }) => {
    const response = await apiFetch(`${API_BASE}/polls/client`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question, expires_at, network_id, location_id }),
    });
    if (!response.ok) {
        throw new Error(await readApiErrorMessage(response, "Не вдалося створити опитування"));
    }
    return await response.json();
};

export const voteClientPoll = async ({ poll_id, answer_yes }) => {
    const response = await apiFetch(`${API_BASE}/polls/client/${poll_id}/vote`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ answer_yes: Boolean(answer_yes) }),
    });
    if (!response.ok) {
        throw new Error(await readApiErrorMessage(response, "Не вдалося проголосувати"));
    }
    return await response.json();
};

export const fetchUnreadClientPolls = async () => {
    const response = await apiFetch(`${API_BASE}/polls/client/unread`);
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};

export const markClientPollsViewed = async () => {
    const response = await apiFetch(`${API_BASE}/polls/client/mark-viewed/polls`, {
        method: "PUT",
    });
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};
